<template>
  <div class="app-pattern-chapter" v-if="warnings && warnings.length > 0">
    <div
      v-for="(warning, index) in warnings"
      :key="index"
      class="app-pattern-notification app-warning"
    >
      <ul>
        <li>
          {{ warning }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  warnings: {
    type: Array,
    default: [],
  },
  addMeasurementWarning: {
    type: Boolean,
    default: false,
  },
});

const warnings = computed(() => {
  if (props.addMeasurementWarning) {
    return [...props.warnings, t("common.Measurement_warning")];
  }
  return props.warnings;
});
</script>

<style lang="scss" scoped>
@import "./../../../scss/pattern.scss";
</style>
